import AssetInventory from "./AssetInventory"
import { ASSET_INVENTORY } from "../../utils/constants/accessDeniedAssetInventory";
import permissions, { isAuthorized } from "client/utils/Permissions";
import LoadingWrapper from "client/CommonComponents/LoadingWrapper";
import { useSelector } from "react-redux";
import userProfileSelectors from '../../../../src/redux/UserProfile/selectors'


const AssetInventoryContainer = () => {

  const {
    userDetails,
  }: any = useSelector(
    (state: any) => ({
      userDetails: userProfileSelectors.getUserDetails(state),
    }));

  const content = isAuthorized(permissions.ViewAssetInventoryModule) ? <AssetInventory /> : <div className="access-denied">
    <h1>ACCESS DENIED</h1>
    <h6>{ASSET_INVENTORY.ACCESS_DENIED}</h6>
  </div>

  return <LoadingWrapper isLoading = {!userDetails?.permissions} data-attribute="AssetInventory_container_Default_LoadingWrapper">{content}</LoadingWrapper>
}
export default AssetInventoryContainer